<!-- SETUP -->
<div class="fondoEntrada alturaEntrada bgcolor-main2"></div>
<div class="container">

  <div class="contenedorEntrada text-white me-2">
    <h4 style="text-wrap: balance;">MI SETUP PARA PROGRAMACIÓN Y CREACIÓN DE CONTENIDO</h4>
  </div>

  <div class="mt-5 pt-5 col-xl-6 col-lg-8 col-sm-11 mx-auto">
    
    <div class="text-uppercase">
      <h4 class="mb-5 color-main2">Consulta lo que uso para realizar mi trabajo como programador y creador de contenido</h4>
      <span class="color-main bold">Si quieres más información, tienes un enlace de compra de cada elemento para que consultes precio y características</span>
    </div>

    <categoriasSetup/>
    <div class="mb-5 pb-5"></div>
</div>